(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["essenza-vitrine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-essenza-collection]');

    sections.forEach((section) => {
      const track = section.querySelector('[data-collection-track]');
      const previousButton = section.querySelector('[data-collection-previous]');
      const nextButton = section.querySelector('[data-collection-next]');

      if (!track || !previousButton || !nextButton) {
        return;
      }

      // Rola exatamente 1 card por clique, em vez de uma fração da largura
      const step = () => {
        const card = track.querySelector('.essenza-product-card');
        if (!card) return track.clientWidth * 0.85;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maximumScroll = track.scrollWidth - track.clientWidth;
        const scrollable = maximumScroll > 4;

        previousButton.disabled = !scrollable || track.scrollLeft <= 2;
        nextButton.disabled = !scrollable || track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('essenza-proof-gallery')) {
  class EssenzaProofGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.bootFrame) return;
      this.bootFrame = requestAnimationFrame(() => {
        this.bootFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      if (!this.querySelector('.sps-shell')) { this.connectedCallback(); return; }
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.editor = this.dataset.editor === 'true';
      this.paused = this.dataset.autoplay === 'false' || this.motion.matches;
      this.inView = true;
      this.hovered = false;
      this.interacting = false;
      this.pointerActive = false;
      this.editorSelected = false;
      this.photoLinks = Array.from(this.querySelectorAll('[data-original] [data-photo-id]'));
      this.dialog = this.querySelector('dialog');
      this.rows = Array.from(this.querySelectorAll('.sps-viewport')).map(view => ({ view, track: view.querySelector('.sps-track'), group: view.querySelector('[data-original]'), reverse: view.dataset.reverse === 'true', width: 0, position: 0 }));
      this.on(this, 'click', event => this.handleClick(event));
      this.on(this, 'focusin', () => this.syncAnimation());
      this.on(this, 'focusout', () => queueMicrotask(() => { if (this.isConnected) this.syncAnimation(); }));
      this.on(this.querySelector('.sps-gallery'), 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.hover === 'true') { this.hovered = true; this.syncAnimation(); }
      });
      this.on(this.querySelector('.sps-gallery'), 'pointerleave', () => { this.hovered = false; this.syncAnimation(); });
      this.on(document, 'visibilitychange', () => this.syncAnimation());
      this.on(this.motion, 'change', () => { this.paused = true; this.rebuild(); });
      this.on(this, 'shopify:block:select', event => {
        this.editorSelected = true;
        this.syncAnimation();
        const card = Array.from(this.querySelectorAll('[data-original] [data-block-id]')).find(item => item.dataset.blockId === event.detail.blockId);
        if (card) {
          const row = card.closest('.sps-viewport');
          row.scrollLeft += card.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - card.offsetWidth) / 2;
        }
      });
      this.on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.syncAnimation(); });
      this.on(document, 'pointerup', () => {
        if (this.pointerActive) { this.pointerActive = false; this.pauseForInteraction(); }
      });
      this.on(document, 'pointercancel', () => { this.pointerActive = false; this.syncAnimation(); });
      this.rows.forEach(row => {
        this.on(row.view, 'pointerdown', event => {
          this.pointerActive = true;
          this.pauseForInteraction();
          if (event.pointerType === 'mouse' && event.button === 0) row.drag = { x: event.clientX, left: row.view.scrollLeft, id: event.pointerId, moved: false };
        });
        this.on(row.view, 'pointermove', event => {
          if (!row.drag) return;
          const distance = event.clientX - row.drag.x;
          if (Math.abs(distance) > 6) {
            row.drag.moved = true;
            row.view.setPointerCapture(event.pointerId);
            event.preventDefault();
            row.view.scrollLeft = row.drag.left - distance;
          }
        });
        const endDrag = () => {
          if (row.drag?.moved) this.suppressClickUntil = performance.now() + 350;
          row.drag = null;
          this.pointerActive = false;
          this.pauseForInteraction();
        };
        this.on(row.view, 'pointerup', endDrag);
        this.on(row.view, 'pointercancel', endDrag);
        this.on(row.view, 'lostpointercapture', endDrag);
        this.on(row.view, 'dragstart', event => event.preventDefault());
        this.on(row.view, 'wheel', event => { if (event.deltaX || event.shiftKey) this.pauseForInteraction(); }, { passive: true });
        this.on(row.view, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.setPaused(true);
            this.stepRow(row, event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
      });
      if (this.dialog) {
        this.on(this.dialog, 'close', () => this.afterClose());
        this.on(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.on(this.dialog, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.photoIndex + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        });
        const stage = this.querySelector('.sps-dialog-stage');
        this.on(stage, 'touchstart', event => {
          this.swipe = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true });
        this.on(stage, 'touchend', event => {
          if (!this.swipe || event.changedTouches.length !== 1) return;
          const dx = event.changedTouches[0].clientX - this.swipe.x;
          const dy = event.changedTouches[0].clientY - this.swipe.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.showPhoto(this.photoIndex + (dx < 0 ? 1 : -1));
          this.swipe = null;
        }, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.syncAnimation(); });
        this.observer.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.rebuild());
        });
        this.rows.forEach(row => { this.resizeObserver.observe(row.view); this.resizeObserver.observe(row.group); });
      } else {
        this.on(window, 'resize', () => this.rebuild());
      }
      this.dataset.ready = 'true';
      this.rebuild();
    }
    on(target, type, fn, options = {}) { target.addEventListener(type, fn, { ...options, signal: this.signal }); }
    cloneGroup(group) {
      const clone = group.cloneNode(true);
      clone.removeAttribute('data-original');
      clone.dataset.clone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('*').forEach(node => {
        node.removeAttribute('id');
        node.removeAttribute('data-shopify-editor-block');
        node.removeAttribute('data-block-id');
      });
      clone.querySelectorAll('a').forEach(link => {
        const span = document.createElement('span');
        span.className = link.className;
        span.dataset.photoId = link.dataset.photoId;
        span.append(...link.childNodes);
        link.replaceWith(span);
      });
      clone.querySelectorAll('img').forEach(img => { img.alt = ''; img.draggable = false; });
      return clone;
    }
    rebuild() {
      if (!this.isConnected || !this.controller) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.rows.forEach(row => {
        const oldWidth = row.width;
        const phase = oldWidth ? ((row.view.scrollLeft % oldWidth) + oldWidth) % oldWidth / oldWidth : 0;
        row.track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
        row.view.removeAttribute('data-loop');
        row.loop = this.dataset.autoplay !== 'false' && !this.motion.matches && row.group.children.length > 1;
        if (row.loop) {
          row.view.dataset.loop = 'true';
          row.width = row.group.getBoundingClientRect().width;
          if (!row.width) { row.loop = false; row.view.removeAttribute('data-loop'); return; }
          row.track.prepend(this.cloneGroup(row.group));
          const needed = Math.ceil(row.view.clientWidth / row.width) + 2;
          for (let i = 0; i < needed; i++) row.track.append(this.cloneGroup(row.group));
          row.position = row.width * (1 + phase);
          row.view.scrollLeft = row.position;
        } else {
          row.width = 0;
        }
      });
      this.syncAnimation();
    }
    pauseForInteraction() {
      this.interacting = true;
      clearTimeout(this.resumeTimer);
      this.syncAnimation();
      this.resumeTimer = setTimeout(() => {
        this.interacting = false;
        if (this.isConnected && this.controller) this.syncAnimation();
      }, 2000);
    }
    setPaused(value) {
      this.paused = value;
      if (!value) { clearTimeout(this.resumeTimer); this.interacting = false; }
      this.syncAnimation();
    }
    shouldRun() {
      const focusedRow = document.activeElement?.matches(':focus-visible') && this.rows.some(row => row.view.contains(document.activeElement));
      return !this.paused && !this.motion.matches && !this.editorSelected && !this.interacting && !this.pointerActive && this.inView && !this.hovered && !focusedRow && !this.dialog?.open && !document.hidden && this.rows.some(row => row.loop);
    }
    syncAnimation() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      if (!this.controller || !this.shouldRun()) return;
      this.rows.forEach(row => { row.position = row.view.scrollLeft; });
      this.lastTime = null;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (!this.shouldRun()) { this.frame = null; return; }
      const elapsed = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 50);
      this.lastTime = time;
      const duration = Math.max(10, Number(this.dataset.duration) || 30) * 1000;
      this.rows.forEach(row => {
        if (!row.loop) return;
        row.position += elapsed * row.width / duration * (row.reverse ? -1 : 1);
        row.position = row.width + ((row.position - row.width) % row.width + row.width) % row.width;
        row.view.scrollLeft = row.position;
      });
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    stepRow(row, direction) {
      const card = row.group.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(row.group).gap) || 0;
      if (row.loop) row.view.scrollLeft = row.width + ((row.view.scrollLeft - row.width) % row.width + row.width) % row.width;
      row.view.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    handleClick(event) {
      const action = event.target.closest('[data-action]');
      if (action) {
        const name = action.dataset.action;
        if (name === 'close') this.dialog?.close();
        if (name === 'photo-next') this.showPhoto(this.photoIndex + 1);
        if (name === 'photo-previous') this.showPhoto(this.photoIndex - 1);
        return;
      }
      const photo = event.target.closest('[data-photo-id]');
      if (!photo || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      event.preventDefault();
      if (performance.now() < (this.suppressClickUntil || 0)) return;
      const index = this.photoLinks.findIndex(link => link.dataset.photoId === photo.dataset.photoId);
      if (index < 0) return;
      this.returnFocus = photo.closest('[data-clone]') ? photo.closest('.sps-viewport') : photo;
      this.showPhoto(index);
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.lockScroll();
      }
      this.syncAnimation();
    }
    showPhoto(index) {
      if (!this.photoLinks.length || !this.dialog) return;
      this.photoIndex = (index + this.photoLinks.length) % this.photoLinks.length;
      const link = this.photoLinks[this.photoIndex];
      const stage = this.querySelector('.sps-dialog-stage');
      const error = this.querySelector('.sps-dialog-error');
      const image = new Image();
      image.alt = link.dataset.alt || '';
      image.decoding = 'async';
      image.draggable = false;
      error.hidden = true;
      image.addEventListener('error', () => {
        if (stage.firstElementChild === image) { error.hidden = false; image.hidden = true; }
      }, { once: true });
      stage.replaceChildren(image);
      image.src = link.href;
      const caption = this.querySelector('.sps-dialog-caption');
      caption.textContent = link.dataset.caption || '';
      caption.hidden = !caption.textContent;
      this.querySelector('.sps-counter').textContent = `${this.photoIndex + 1} / ${this.photoLinks.length}`;
      this.querySelectorAll('[data-action="photo-next"], [data-action="photo-previous"]').forEach(button => { button.hidden = this.photoLinks.length < 2; });
    }
    lockScroll() {
      if (this.locked) return;
      const type = this.constructor;
      if (!type.lockCount) {
        type.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      type.lockCount = (type.lockCount || 0) + 1;
      this.locked = true;
    }
    unlockScroll() {
      if (!this.locked) return;
      const type = this.constructor;
      type.lockCount = Math.max(0, (type.lockCount || 1) - 1);
      if (!type.lockCount) document.documentElement.style.overflow = type.oldOverflow || '';
      this.locked = false;
    }
    afterClose() {
      this.unlockScroll();
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      this.syncAnimation();
    }
    disconnectedCallback() {
      clearTimeout(this.resumeTimer);
      cancelAnimationFrame(this.bootFrame);
      this.bootFrame = null;
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.resizeFrame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.unlockScroll();
      if (this.dialog?.open) this.dialog.close();
      this.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
    }
  }
  customElements.define('essenza-proof-gallery', EssenzaProofGallery);
}

  } catch(e) { console.error(e); }
})();
})();
